import {
	DocumentsViewModel,
	DocumentItemViewModel,
	DocumentItemType,
	DocumentsViewType
} from "client/Api/Documents/SharePoint/common";
import { documentsConfiguration } from "client_legacy/ndaw/workspaceAbilitiesStatusProvider";

export function canMoveTo(
	selection: readonly DocumentItemViewModel[],
	view: DocumentsViewModel
): boolean {
	// OneNote notebooks are also folders, so we don't check for them separate
	const foldersCanBeMoved: boolean = view.supportsMovingFolders;

	return view.type === DocumentsViewType.EditableView
		&& selection.length >= 1
		&& selection.every((x) => {
			return (foldersCanBeMoved || x.itemType === DocumentItemType.File)
			&& x.permissions.canEdit;
		});
}

export function canDelete(
	selection: readonly DocumentItemViewModel[],
	view: DocumentsViewModel,
	isRootFolder: boolean
): boolean {
	return !(view.type === DocumentsViewType.SharedWithMeView && isRootFolder)
		&& selection.length >= 1
		&& selection.every(x => x.permissions.canDelete);
}

export function canCopy(
	selection: readonly DocumentItemViewModel[],
	view: DocumentsViewModel
): boolean {
	const { allowCrossStoreOperations } = documentsConfiguration();
	const isSingleFile: boolean = selection.length === 1
		&& selection[0].itemType === DocumentItemType.File;

	return view.type !== DocumentsViewType.SharedWithMeView
		&& (selection.length >= 1 && allowCrossStoreOperations) || isSingleFile;
}

export function canDownloadSingleFile(selection: readonly DocumentItemViewModel[]): boolean {
	return selection.length === 1
		&& selection[0].itemType === DocumentItemType.File
		&& selection[0].permissions.canDownload;//We can download only single file
}

export function canRename(
	selection: readonly DocumentItemViewModel[],
	view: DocumentsViewModel
): boolean {
	return view.type !== DocumentsViewType.SharedWithMeView
		&& selection.length === 1
		&& selection[0].permissions.canEdit;
}

export function canManagePermissions(selection: readonly DocumentItemViewModel[]): boolean {
	return selection.length === 1
		&& selection[0].permissions
			.canManagePermissions;
}

export function canShareLink(
	selection: readonly DocumentItemViewModel[],
	view: DocumentsViewModel,
	isSharingViaLinkEnabled: boolean
): boolean {
	return isSharingViaLinkEnabled
		&& selection.length === 1
		&& view.type !== DocumentsViewType.SharedWithMeView
		&& (
			selection[0].itemType === DocumentItemType.File
			|| selection[0].itemType === DocumentItemType.OneNoteNotebook
		);
}

export function canCheckVersionHistory(
	selection: readonly DocumentItemViewModel[],
	isVersioningEnabled: boolean
): boolean{
	return isVersioningEnabled
		&& selection.length === 1
		&& selection[0].itemType === DocumentItemType.File;
}